import React from "react";
import { Avatar } from "@bookingcom/bui-react";
import { PickerMobile } from "../Picker";
import "./LanguagePicker.types";
import styles from "./LanguagePicker.module.css";
var LanguagePickerMobile = function (props) {
    var children = props.children, languageSelection = props.languageSelection, selectedLanguageId = props.selectedLanguageId, selectedFlagUrl = props.selectedFlagUrl, shouldDisplaySelectionTitle = props.shouldDisplaySelectionTitle, attributes = props.attributes, triggerAttributes = props.triggerAttributes, onOpen = props.onOpen, onClose = props.onClose;
    var renderSign = function (item) {
        return (React.createElement(Avatar, { className: styles.flag, src: item.flagUrl, backgroundSize: item.backgroundSize, backgroundPosition: item.backgroundPosition, size: "small" }));
    };
    var renderSelectedSign = function (item) {
        return selectedFlagUrl ? (React.createElement(Avatar, { className: styles.flag, src: selectedFlagUrl, size: "small" })) : (renderSign(item));
    };
    return (React.createElement(PickerMobile, { selection: languageSelection, selectedId: selectedLanguageId, shouldDisplaySelectionTitle: shouldDisplaySelectionTitle, attributes: attributes, triggerAttributes: triggerAttributes, renderSign: renderSign, renderSelectedSign: renderSelectedSign, onOpen: onOpen, onClose: onClose }, children));
};
export default LanguagePickerMobile;
